<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">{{ $t('report_customer_loan') }}</li>
    </ol>
    <div class="x_header">
      <div class="pull-left">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
          <i class="fa fa-arrow-circle-o-left"></i>
          {{ $t('back') }}
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
          <i class="fa fa-print"></i>
          {{$t('print')}}
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
          {{$t('export_excel')}}
        </button>
      </div>
      <div class="pull-right">
        <div class="form-inline">
          <div class="form-group">
            <input type="date" class="form-control form-control-sm" v-model="query.FromDate"/>
          </div>&nbsp;
          <div class="form-group">
            <input type="date" class="form-control form-control-sm" v-model="query.ToDate"/>
          </div>
          <div class="form-group">
            <button class="btn btn-default btn-sm" @click="toList">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="x_body">
      <div class="card x_card">
        <div class="card-body">
          <h4 class="text-center font-m">{{$t('report_customer_loan')}}</h4>
          <table class="table table-bordered table-sm table-striped no-bor">
            <thead>
            <tr>
              <th style="width: 50px;">#</th>
              <th>{{$t('customer')}}</th>
              <th class="text-right">{{$t('balance')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(ret, index) in list" :key="index">
              <td>{{index+1}}</td>
              <td>{{ret.CustomerName}}</td>
              <td class="text-right">{{$money(ret.Balance + ret.Balance)}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <span>{{$t('total_record')}}: {{query.Total}}</span>
          <div class="pull-right">
            <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                          hide-goto-end-buttons
                          @change="paging($event)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data: function(){
      return {
        query:{
          FromDate: '',
          ToDate: '',
          Page: 1,
          Total: 0,
          Limit: 25
        },
        list: [],
        summary: {
          balance: 0
        }
      }
    },
    created: function(){
      this.toList();
    },
    methods: {
      toList(){
        var loading = this.$loading.show();
        this.$api().post('sale/invoices', this.query).then(res => {
          if(this.$isValid(res)){
            this.list = res.data.Data;
          }
        }).finally(function() { loading.hide(); });
      },
      print() {
        window.open(
                "/print/ARPreview",
                "_blank"
        );
      },
      exportExcel(){
        var loading = this.$loading.show();
        this.$api()({
          url: this.$base() + 'report/ARPreview/export/excel',
          method: 'post',
          data: this.query,
          responseType: 'blob',
        }).then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'report-ARPreview.xlsx');
          document.body.appendChild(link);
          link.click();
        }).finally(function(){ loading.hide();});
      }
    }
  }
</script>
